import React from 'react';
import { Screen, Text } from '../../../../components';

export const Terms = () => (
  <Screen>
    <Text title="checklists" />
  </Screen>
);
